import React, { createContext, useContext } from 'react'
//import { useLocalStorage } from '@uidotdev/usehooks' //FIXME: https://github.com/uidotdev/usehooks/issues/264
import {
  tsGetAnimalsInContainer,
  tsGetSampleRun,
  tsGetScreenCollection,
} from '../../../Typescript/API_Response'
import { useLocation } from 'react-router-dom'

interface AddSampleContextInterface {
  collection: tsGetScreenCollection | tsGetAnimalsInContainer | undefined
  sampleRun: tsGetSampleRun | undefined
}

const AddSampleContext = createContext<AddSampleContextInterface>(
  {} as AddSampleContextInterface,
)
export const useAddSampleContext = () => useContext(AddSampleContext)

function AddSampleModule({ children }: { children: any }) {
  const location = useLocation()
  return (
    <AddSampleContext.Provider
      value={{
        collection: location?.state?.container ?? location?.state?.collection,
        sampleRun: location?.state?.sampleRun,
      }}
    >
      {children}
    </AddSampleContext.Provider>
  )
}

export default AddSampleModule
